import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';
import SearchScreenNav from '../components/SearchScreenNav';

const Contact = () => {
  return (
    <div className="contact-page-container">
      <Helmet>
        <title>Contact Us | LGBT PridePath</title>
        <meta name="description" content="Contact the LGBT National Help Center. Phone: 415-355-0003. Email: help@lgbthotline.org. Located in San Francisco, CA. Free and confidential support." />
        <link rel="canonical" href="https://www.lgbtpridepath.org/contact" />
      </Helmet>
      
      {/* Custom navigation for overlay effect */}
      <SearchScreenNav />
      
      {/* Hero image container - positioned OUTSIDE content wrapper like video in SearchScreen */}
      <div className="contact-hero-image-container">
        <img src={require('../assets/header-contact.png')} alt="Person on phone" />
      </div>
      
      {/* Content wrapper matching SearchScreen structure */}
      <div className="contact-content-wrapper">
        {/* Hero section - like info-section in SearchScreen */}
        <div className="contact-hero-section">
          <h2 className="contact-hero-subtitle">CONTACT US</h2>
          <h1 className="contact-hero-title">No Matter How You Reach Out, We're Here</h1>
        </div>
      </div>

      {/* Other Ways Section - appears on white background from pseudo-element */}
      <section className="contact-other-ways-section">
        <div className="contact-other-ways-content">
          <div className="contact-other-ways-image">
            <img src={require('../assets/ContactLOWER.png')} alt="Person reading" />
            <div className="contact-other-ways-image-overlay">
              <h3>Other Ways<br/>to Get in<br/>Touch</h3>
            </div>
          </div>
          <div className="contact-other-ways-text">
            <div className="contact-section-header"></div>
            <div className="contact-services-box">
              <h3>ADMINISTRATIVE</h3>
              <div className="contact-info-grid">
                {/* Left Column */}
                <div className="contact-info-column">
                  <div className="contact-info-item">
                    <p className="contact-info-label">PHONE:</p>
                    <a href="tel:415-355-0003" className="contact-info-phone">415-355-0003</a>
                  </div>

                  <div className="contact-info-item">
                    <p className="contact-info-label">EMAIL:</p>
                    <p className="contact-info-value">
                    <a href="mailto:HELP@LGBTHOTLINE.ORG" aria-label="Email LGBT Hotline">
                      HELP@LGBTHOTLINE.ORG
                    </a>
                  </p>                  
                  </div>

                  <div className="contact-info-item">
                    <p className="contact-info-label">MAILING ADDRESS:</p>
                    <p className="contact-info-value">
                      LGBT NATIONAL HELP CENTER<br />
                      2261 MARKET STREET, #296<br />
                      SAN FRANCISCO, CA 94114
                    </p>
                  </div>
                </div>

                {/* Right Column */}
                <div className="contact-info-column">
                  <div className="contact-info-item">
                    <p className="contact-info-label">FEDERAL TAX ID:</p>
                    <p className="contact-info-value">13-3850982</p>
                    <p className="contact-info-note">(LISTED WITH THE IRS AS THE GLBT NATIONAL HELP CENTER)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default Contact;